import template from './templates/pdp-info-tabs';

const parsedTemplate = $.parseHTML(template);

export default class PdpInfoTabs {
    constructor({ $el, data, labels } = { data: {}, labels: {} }) {
        $el.replaceWith(parsedTemplate);
        
        this.$el = $(parsedTemplate);

        // non-dynamic labels regions
        this.$informationLabel = this.$el.find('[data-label="information"]');
        this.$ingredientsLabel = this.$el.find('[data-label="ingredients"]');
        this.$speciesLabel = this.$el.find('[data-label="species"]');
        this.$usageLabel = this.$el.find('[data-label="usage"]');

        // dynamic data regions
        this.$information = this.$el.find('[data-region="information"]');
        this.$informationContainer = this.$el.find('[data-region="informationContainer"]');
        this.$ingredients = this.$el.find('[data-region="ingredients"]');
        this.$ingredientsContainer = this.$el.find('[data-region="ingredientsContainer"]');
        this.$species = this.$el.find('[data-region="species"]');
        this.$speciesContainer = this.$el.find('[data-region="speciesContainer"]');
        this.$usage = this.$el.find('[data-region="usage"]');
        this.$usageContainer = this.$el.find('[data-region="usageContainer"]');

        // ui controls
        this.$informationCtrl = this.$el.find('[data-control="information"]');
        this.$ingredientsCtrl = this.$el.find('[data-control="ingredients"]');
        this.$speciesCtrl = this.$el.find('[data-control="species"]');
        this.$usageCtrl = this.$el.find('[data-control="usage"]');
        
        this.productInformation = '';
        this.ingredients = '';
        this.species = '';
        this.usage = '';

        this.isHidden = false;

        this.labels = labels;

        this.setData(data);

        this.init();
    }

    hideEmptySections() {
        if(this.isHidden) {
            this.$el.hide();
            return;
        }

        this.$informationContainer.show();
        this.$ingredientsContainer.show();
        this.$speciesContainer.show();
        this.$usageContainer.show();

        if(!this.productInformation) {
            this.$informationContainer.hide();
        }

        if(!this.ingredients) {
            this.$ingredientsContainer.hide();
        }

        if(!this.species) {
            this.$speciesContainer.hide();
        }        

        if(!this.usage) {
            this.$usageContainer.hide();
        }

        const $first = [
            this.$informationContainer,
            this.$ingredientsContainer,
            this.$speciesContainer,
            this.$usageContainer
        ].find($container => $container.is(':visible'));

        this.showSection($first);
    }

    init() {
        this.hideEmptySections();
        this.renderLabels();
        this.renderRegions();
    }

    renderLabels() {
        this.$informationLabel.html(this.labels.ProductInformation);
        this.$ingredientsLabel.html(this.labels.ActiveIngredients);
        this.$speciesLabel.html(this.labels.DevelopedFor);
        this.$usageLabel.html(this.labels.UsageGuidelines);
    }

    renderRegions() {
        this.$information.html(this.productInformation)
        this.$ingredients.html(this.ingredients);
        this.$species.html(this.species);
        this.$usage.html(this.usage);
    }

    setData(data) {
        this.productInformation = data.productInformation;
        this.ingredients = data.ingredients;
        this.species = data.species;
        this.usage = data.usage;

        this.isHidden = Object.values(data).every(value => !value);
    }

    showSection($container) {
        $container.addClass('-first');

        $container.each((i, el) => {
            const ctrl = el.querySelector('[data-control]');
            const type = ctrl?.dataset.toggle;

            if(type === 'tab') {
                $(ctrl).tab('show');
            } else if (type === 'collapse') {
                const $target = $(ctrl.dataset.target);
                $target.collapse('show');
            }
        });
    }

    update(data) {
        this.setData(data);
        this.hideEmptySections();
        this.renderRegions();
    }
}
